export const initialState = null;

export const getFocus = (state = initialState) => state;



// WEBPACK FOOTER //
// ./src/store/focus/selectors.js